<div class="category-header">
    <div class="category">
        <div class="category-icon-container">
            <img [src]="categoryIconUri()" alt="">
        </div>
        <div>
            <h1 class="hb-h4">{{ categoryTitle() }}</h1>
            <p class="hb-text--sm">Kategori {{ categoryNumber() }} av {{ categoryTotal() }}</p>
        </div>
    </div>
    <div role="progressbar" class="progress-bar"
         [attr.aria-valuenow]="currentQuestion()" [attr.aria-valuemin]="0"
         [attr.aria-valuemax]="totalQuestions()"
         [attr.aria-label]="currentQuestion() + ' av ' + totalQuestions() + ' spørsmål besvart innen '+ categoryTitle()">
        <div class="progress-bar-value"
             [style.width.%]="(currentQuestion() / totalQuestions()) * 100"
        ></div>
    </div>
</div>
